// AJAX CART LOGIC - V8 ULTIMATE (Brazil Edition)
// Phase 4C-B: customer-facing BR / INTL fulfillment labels and mixed-shipment notice.
document.addEventListener('DOMContentLoaded', function() {
  const overlay = document.getElementById('tpb-cart-overlay');
  const drawer = document.getElementById('tpb-cart-drawer');
  const closeBtn = document.getElementById('tpb-close-cart');
  const itemsContainer = document.getElementById('tpb-cart-items-container');
  const subtotalDisplay = document.getElementById('tpb-cart-subtotal');
  const countDisplay = document.getElementById('tpb-cart-count');
  const checkoutActions = drawer ? drawer.querySelector('.tpb-drawer-checkout-actions') : null;
  const checkoutForm = drawer ? drawer.querySelector('.tpb-checkout-form') : null;
  const originalCheckoutBtn = drawer ? drawer.querySelector('.tpb-btn-checkout') : null;

  if (!overlay || !drawer || !closeBtn || !itemsContainer || !subtotalDisplay || !countDisplay) return;

  let localCartState = null;
  let lastInteractionTime = 0;
  let isSyncing = false;

  // Mobile floating checkout CTA.
  // The floating copy is mounted on document.body, not inside the transformed/
  // scrollable drawer. This ensures position:fixed is anchored to the real mobile
  // visual viewport. It stays visible while the original checkout button is below
  // the viewport, then disappears when the original button reaches the same place.
  let floatingCheckout = null;
  let floatingCheckoutBtn = null;
  let floatingCheckoutFrame = 0;

  const isMobileCartViewport = () => window.matchMedia('(max-width: 992px)').matches;

  const setFloatingCheckoutVisible = (visible) => {
    if (!floatingCheckout) return;

    const shouldShow = Boolean(visible);
    floatingCheckout.classList.toggle('is-visible', shouldShow);
    floatingCheckout.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

    // Keep the original button in the document flow, but make it visually absent
    // while the floating copy is active. This prevents two purple buttons from
    // being visible through each other during the handoff.
    if (originalCheckoutBtn) {
      originalCheckoutBtn.classList.toggle('is-float-covered', shouldShow);
      originalCheckoutBtn.setAttribute('aria-hidden', shouldShow ? 'true' : 'false');
    }
  };

  const syncFloatingCheckoutButton = () => {
    if (!floatingCheckoutBtn || !originalCheckoutBtn) return;

    floatingCheckoutBtn.textContent = originalCheckoutBtn.textContent;
    floatingCheckoutBtn.disabled = originalCheckoutBtn.disabled;
    floatingCheckoutBtn.style.opacity = originalCheckoutBtn.style.opacity || '';
    floatingCheckoutBtn.style.cursor = originalCheckoutBtn.style.cursor || '';
  };

  const updateFloatingCheckoutPosition = () => {
    if (floatingCheckoutFrame) cancelAnimationFrame(floatingCheckoutFrame);

    floatingCheckoutFrame = requestAnimationFrame(() => {
      floatingCheckoutFrame = 0;

      if (!floatingCheckout || !originalCheckoutBtn) return;

      const cartIsOpen = drawer.classList.contains('is-active');
      const itemCount = localCartState
        ? Number(localCartState.item_count || 0)
        : Number(countDisplay.textContent || 0);

      if (!cartIsOpen || !isMobileCartViewport() || itemCount <= 0) {
        setFloatingCheckoutVisible(false);
        return;
      }

      syncFloatingCheckoutButton();

      const drawerRect = drawer.getBoundingClientRect();
      const visualViewport = window.visualViewport;
      const viewportTop = visualViewport && Number.isFinite(visualViewport.offsetTop)
        ? visualViewport.offsetTop
        : 0;
      const viewportHeight = visualViewport && visualViewport.height
        ? visualViewport.height
        : window.innerHeight;
      const viewportBottom = viewportTop + viewportHeight;

      // Match the floating CTA to the actual drawer width and horizontal position.
      floatingCheckout.style.left = Math.max(0, Math.round(drawerRect.left)) + 'px';
      floatingCheckout.style.width = Math.max(1, Math.round(drawerRect.width)) + 'px';

      // The element remains measurable while hidden because it uses visibility,
      // not display:none, inside the mobile media query.
      const floatingHeight = Math.max(
        1,
        Math.round(floatingCheckout.getBoundingClientRect().height || 92)
      );
      const bottomGap = 10;
      const floatingTop = Math.max(
        viewportTop + 8,
        viewportBottom - floatingHeight - bottomGap
      );

      floatingCheckout.style.top = Math.round(floatingTop) + 'px';

      const originalRect = originalCheckoutBtn.getBoundingClientRect();
      const floatingButtonRect = floatingCheckoutBtn
        ? floatingCheckoutBtn.getBoundingClientRect()
        : floatingCheckout.getBoundingClientRect();

      // Handoff at the real button edge rather than at the wrapper edge. The
      // original remains transparent until both buttons occupy effectively the
      // same vertical position, which makes the transition visually seamless.
      const handoffLine = floatingButtonRect.top + 2;
      const originalReachedNaturalPosition = originalRect.top <= handoffLine;

      setFloatingCheckoutVisible(!originalReachedNaturalPosition);
    });
  };

  const setupFloatingCheckout = () => {
    if (!checkoutForm || !originalCheckoutBtn || floatingCheckout) return;

    floatingCheckout = document.createElement('div');
    floatingCheckout.className = 'tpb-floating-checkout';
    floatingCheckout.setAttribute('aria-hidden', 'true');

    floatingCheckoutBtn = document.createElement('button');
    floatingCheckoutBtn.type = 'button';
    floatingCheckoutBtn.className = 'tpb-btn-checkout tpb-btn-checkout-floating';
    floatingCheckoutBtn.textContent = originalCheckoutBtn.textContent;

    floatingCheckout.appendChild(floatingCheckoutBtn);

    // IMPORTANT: mount outside the drawer. The drawer itself is transformed and
    // scrollable, which can make fixed descendants behave like normal descendants.
    document.body.appendChild(floatingCheckout);

    floatingCheckoutBtn.addEventListener('click', function() {
      if (floatingCheckoutBtn.disabled || originalCheckoutBtn.disabled) return;

      if (typeof checkoutForm.requestSubmit === 'function') {
        checkoutForm.requestSubmit(originalCheckoutBtn);
      } else {
        originalCheckoutBtn.click();
      }
    });

    drawer.addEventListener('scroll', updateFloatingCheckoutPosition, { passive: true });
    window.addEventListener('resize', updateFloatingCheckoutPosition, { passive: true });
    window.addEventListener('orientationchange', updateFloatingCheckoutPosition, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateFloatingCheckoutPosition, { passive: true });
      window.visualViewport.addEventListener('scroll', updateFloatingCheckoutPosition, { passive: true });
    }

    syncFloatingCheckoutButton();
  };

  setupFloatingCheckout();

  // Mobile browser viewport + page scroll lock.
  // The drawer uses the real visual viewport height so browser toolbars do not cover it.
  // The page itself is fixed while the drawer is open so swipe/overscroll cannot reveal
  // the storefront behind the drawer.
  let lockedPageScrollY = 0;
  let pageScrollLocked = false;
  let viewportTrackingActive = false;
  const savedBodyStyles = {};
  const savedHtmlStyles = {};

  const saveInlineProperty = (element, store, property) => {
    store[property] = {
      value: element.style.getPropertyValue(property),
      priority: element.style.getPropertyPriority(property)
    };
  };

  const restoreInlineProperties = (element, store) => {
    Object.keys(store).forEach(property => {
      const previous = store[property];
      if (previous && previous.value) {
        element.style.setProperty(property, previous.value, previous.priority || '');
      } else {
        element.style.removeProperty(property);
      }
      delete store[property];
    });
  };

  const updateCartViewportMetrics = () => {
    const visualViewport = window.visualViewport;
    const viewportHeight = visualViewport && visualViewport.height
      ? visualViewport.height
      : window.innerHeight;

    const viewportOffsetTop = visualViewport && Number.isFinite(visualViewport.offsetTop)
      ? visualViewport.offsetTop
      : 0;

    document.documentElement.style.setProperty(
      '--tpb-cart-viewport-height',
      Math.max(1, Math.round(viewportHeight)) + 'px'
    );
    document.documentElement.style.setProperty(
      '--tpb-cart-viewport-offset-top',
      Math.max(0, Math.round(viewportOffsetTop)) + 'px'
    );

    updateFloatingCheckoutPosition();
  };

  const startCartViewportTracking = () => {
    if (viewportTrackingActive) return;
    viewportTrackingActive = true;
    updateCartViewportMetrics();

    window.addEventListener('resize', updateCartViewportMetrics, { passive: true });
    window.addEventListener('orientationchange', updateCartViewportMetrics, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateCartViewportMetrics, { passive: true });
      window.visualViewport.addEventListener('scroll', updateCartViewportMetrics, { passive: true });
    }
  };

  const stopCartViewportTracking = () => {
    if (!viewportTrackingActive) return;
    viewportTrackingActive = false;

    window.removeEventListener('resize', updateCartViewportMetrics);
    window.removeEventListener('orientationchange', updateCartViewportMetrics);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', updateCartViewportMetrics);
      window.visualViewport.removeEventListener('scroll', updateCartViewportMetrics);
    }
  };

  const lockStorefrontScroll = () => {
    if (pageScrollLocked) return;
    pageScrollLocked = true;
    lockedPageScrollY = window.scrollY || window.pageYOffset || 0;

    const body = document.body;
    const html = document.documentElement;

    ['position', 'top', 'left', 'right', 'width', 'overflow', 'touch-action'].forEach(property => {
      saveInlineProperty(body, savedBodyStyles, property);
    });
    ['overflow', 'overscroll-behavior'].forEach(property => {
      saveInlineProperty(html, savedHtmlStyles, property);
    });

    html.classList.add('tpb-cart-drawer-open');
    body.classList.add('tpb-cart-drawer-open');

    html.style.setProperty('overflow', 'hidden', 'important');
    html.style.setProperty('overscroll-behavior', 'none', 'important');

    body.style.setProperty('position', 'fixed', 'important');
    body.style.setProperty('top', '-' + lockedPageScrollY + 'px', 'important');
    body.style.setProperty('left', '0', 'important');
    body.style.setProperty('right', '0', 'important');
    body.style.setProperty('width', '100%', 'important');
    body.style.setProperty('overflow', 'hidden', 'important');
    body.style.setProperty('touch-action', 'none', 'important');
  };

  const unlockStorefrontScroll = () => {
    if (!pageScrollLocked) return;
    pageScrollLocked = false;

    const body = document.body;
    const html = document.documentElement;

    html.classList.remove('tpb-cart-drawer-open');
    body.classList.remove('tpb-cart-drawer-open');

    restoreInlineProperties(body, savedBodyStyles);
    restoreInlineProperties(html, savedHtmlStyles);

    window.scrollTo(0, lockedPageScrollY);
  };

  // Shopify Inbox is injected as a floating app embed and may live inside an iframe
  // or Shadow DOM. Static CSS selectors are therefore not reliable enough.
  // Keep a reversible record of any launcher/container hidden while the cart is open.
  const hiddenInboxNodes = new Map();
  let inboxObserver = null;
  let inboxSweepTimer = null;

  const getParentAcrossShadowRoot = (element) => {
    if (!element) return null;
    if (element.parentElement) return element.parentElement;

    const root = typeof element.getRootNode === 'function' ? element.getRootNode() : null;
    return root && root.host ? root.host : null;
  };

  const getElementSignature = (element) => {
    if (!(element instanceof Element)) return '';

    const values = [
      element.tagName,
      element.id,
      element.className,
      element.getAttribute('name'),
      element.getAttribute('title'),
      element.getAttribute('aria-label'),
      element.getAttribute('data-testid'),
      element.getAttribute('data-shopify-chat'),
      element.getAttribute('src')
    ];

    return values
      .map(value => typeof value === 'string' ? value : '')
      .join(' ')
      .toLowerCase();
  };

  const hasInboxSignature = (element) => {
    const signature = getElementSignature(element);

    return /shopify[-_ ]?(chat|inbox)|(?:chat|inbox)[-_ ]?shopify|dummy[-_ ]?chat|online[-_ ]?store[-_ ]?chat|chat[-_ ]?(button|launcher|bubble|widget|iframe)|inbox[-_ ]?(button|launcher|bubble|widget|iframe)/i.test(signature);
  };

  const isBottomRightFloatingWidget = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element.closest('#tpb-cart-drawer, #tpb-cart-overlay')) return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (style.position !== 'fixed' && style.position !== 'sticky') return false;

    const rect = element.getBoundingClientRect();
    if (rect.width < 24 || rect.height < 24) return false;
    if (rect.width > 520 || rect.height > 760) return false;

    const rightGap = Math.abs(window.innerWidth - rect.right);
    const bottomGap = Math.abs(window.innerHeight - rect.bottom);
    const zIndex = Number.parseInt(style.zIndex, 10);

    return rightGap <= 180
      && bottomGap <= 180
      && (Number.isNaN(zIndex) || zIndex >= 1000)
      && (element.tagName === 'IFRAME' || element.tagName.includes('-') || hasInboxSignature(element));
  };

  const findInboxHideTarget = (node) => {
    let current = node instanceof Element ? node : null;
    let best = current;

    for (let depth = 0; current && depth < 8; depth += 1) {
      if (current.closest && current.closest('#tpb-cart-drawer, #tpb-cart-overlay')) return null;

      if (hasInboxSignature(current) || isBottomRightFloatingWidget(current)) {
        best = current;
      }

      const style = current instanceof HTMLElement ? window.getComputedStyle(current) : null;
      if (style && style.position === 'fixed') {
        best = current;
      }

      current = getParentAcrossShadowRoot(current);
      if (current === document.body || current === document.documentElement) break;
    }

    return best;
  };

  const rememberAndHideInboxNode = (element) => {
    if (!(element instanceof HTMLElement)) return;
    if (hiddenInboxNodes.has(element)) return;

    const state = {};
    ['display', 'visibility', 'opacity', 'pointer-events'].forEach(property => {
      state[property] = {
        value: element.style.getPropertyValue(property),
        priority: element.style.getPropertyPriority(property)
      };
    });

    hiddenInboxNodes.set(element, state);
    element.setAttribute('data-tpb-inbox-hidden-by-cart', 'true');
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('opacity', '0', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
  };

  const restoreInboxNodes = () => {
    hiddenInboxNodes.forEach((state, element) => {
      if (!element || !element.style) return;

      Object.entries(state).forEach(([property, previous]) => {
        if (previous.value) {
          element.style.setProperty(property, previous.value, previous.priority || '');
        } else {
          element.style.removeProperty(property);
        }
      });

      element.removeAttribute('data-tpb-inbox-hidden-by-cart');
    });

    hiddenInboxNodes.clear();
  };

  const scanRootForInbox = (root) => {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    let candidates = [];
    const selector = [
      'iframe',
      'shopify-chat',
      'shopify-inbox',
      '[id*="shopify-chat" i]',
      '[id*="shopify-inbox" i]',
      '[class*="shopify-chat" i]',
      '[class*="shopify-inbox" i]',
      '[id*="chat-button" i]',
      '[class*="chat-button" i]',
      '[title*="chat" i]',
      '[aria-label*="chat" i]',
      '[data-testid*="chat" i]'
    ].join(',');

    try {
      candidates = Array.from(root.querySelectorAll(selector));
    } catch (error) {
      candidates = Array.from(root.querySelectorAll('iframe, [id], [class], [title], [aria-label]'));
    }

    candidates.forEach(candidate => {
      if (!hasInboxSignature(candidate) && !isBottomRightFloatingWidget(candidate)) return;
      const target = findInboxHideTarget(candidate);
      if (target) rememberAndHideInboxNode(target);
    });

    // Recursively inspect open Shadow DOM roots. Shopify may render the launcher there.
    root.querySelectorAll('*').forEach(element => {
      if (element.shadowRoot) scanRootForInbox(element.shadowRoot);

      // Closed Shadow DOM cannot be traversed, so hide a matching/floating host instead.
      if ((hasInboxSignature(element) || isBottomRightFloatingWidget(element)) && !element.closest('#tpb-cart-drawer, #tpb-cart-overlay')) {
        const target = findInboxHideTarget(element);
        if (target) rememberAndHideInboxNode(target);
      }
    });
  };

  const hideShopifyInboxForCart = () => {
    scanRootForInbox(document);

    if (!inboxObserver && document.body) {
      inboxObserver = new MutationObserver(() => {
        if (document.body.classList.contains('tpb-cart-drawer-open')) {
          scanRootForInbox(document);
        }
      });

      inboxObserver.observe(document.body, { childList: true, subtree: true });
    }

    // The app embed can finish mounting after the cart opens. Sweep briefly to catch it.
    let sweeps = 0;
    window.clearInterval(inboxSweepTimer);
    inboxSweepTimer = window.setInterval(() => {
      sweeps += 1;
      scanRootForInbox(document);
      if (sweeps >= 15 || !document.body.classList.contains('tpb-cart-drawer-open')) {
        window.clearInterval(inboxSweepTimer);
        inboxSweepTimer = null;
      }
    }, 150);
  };

  const restoreShopifyInboxAfterCart = () => {
    window.clearInterval(inboxSweepTimer);
    inboxSweepTimer = null;

    if (inboxObserver) {
      inboxObserver.disconnect();
      inboxObserver = null;
    }

    restoreInboxNodes();
  };

  const formatMoney = (cents) => 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');

  const escapeHTML = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const normalizeText = (value) => String(value == null ? '' : value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

  const isFulfillmentOptionName = (name) => {
    const normalized = normalizeText(name);
    return normalized === 'origem do envio'
      || normalized === 'origem de envio'
      || normalized === 'shipping origin'
      || normalized === 'fulfillment origin';
  };

  const classifyOriginValue = (value) => {
    const normalized = normalizeText(value);

    if (normalized === 'brasil' || normalized === 'brazil' || normalized === 'br') {
      return 'brasil';
    }

    if (normalized === 'internacional' || normalized === 'international' || normalized === 'intl') {
      return 'international';
    }

    return null;
  };

  // Uses the named option data returned by /cart.js. The SKU is intentionally not used
  // to determine the customer-facing shipping origin.
  const getItemPresentation = (item) => {
    const namedOptions = Array.isArray(item.options_with_values)
      ? item.options_with_values
      : [];

    let hasFulfillmentOption = false;
    let origin = 'standard';
    let visibleValues = [];

    if (namedOptions.length > 0) {
      namedOptions.forEach(function(option) {
        if (isFulfillmentOptionName(option.name)) {
          hasFulfillmentOption = true;
          origin = classifyOriginValue(option.value) || 'unknown';
          return;
        }

        if (option.value && option.value !== 'Default Title') {
          visibleValues.push(String(option.value));
        }
      });
    } else {
      // Compatibility fallback for older/custom cart responses without option names.
      const rawValues = Array.isArray(item.variant_options) && item.variant_options.length > 0
        ? item.variant_options.slice()
        : (item.variant_title && item.variant_title !== 'Default Title'
          ? String(item.variant_title).split('/').map(function(value) { return value.trim(); })
          : []);

      rawValues.forEach(function(value) {
        const fallbackOrigin = classifyOriginValue(value);
        if (fallbackOrigin) {
          hasFulfillmentOption = true;
          origin = fallbackOrigin;
          return;
        }

        if (value && value !== 'Default Title') visibleValues.push(String(value));
      });
    }

    if (visibleValues.length === 0 && !hasFulfillmentOption && item.variant_title && item.variant_title !== 'Default Title') {
      visibleValues = [String(item.variant_title)];
    }

    return {
      origin: origin,
      hasFulfillmentOption: hasFulfillmentOption,
      variantLabel: visibleValues.join(' / ')
    };
  };

  const renderFulfillmentLabel = (presentation) => {
    if (presentation.origin === 'brasil') {
      return `
        <div class="tpb-item-fulfillment is-local" aria-label="Envio local, estoque no Brasil">
          <span class="tpb-item-fulfillment-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 7h11v10H3z"></path>
              <path d="M14 10h3.5L21 14v3h-7z"></path>
              <circle cx="7" cy="18" r="2"></circle>
              <circle cx="17" cy="18" r="2"></circle>
            </svg>
          </span>
          <span class="tpb-item-fulfillment-copy">
            <strong>Envio local</strong>
            <small>Estoque no Brasil</small>
          </span>
        </div>
      `;
    }

    if (presentation.origin === 'international') {
      return `
        <div class="tpb-item-fulfillment is-international" aria-label="Envio internacional, entrega estimada em 12 a 20 dias">
          <span class="tpb-item-fulfillment-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 2L11 13"></path>
              <path d="M22 2L15 22L11 13L2 9L22 2Z"></path>
            </svg>
          </span>
          <span class="tpb-item-fulfillment-copy">
            <strong>Envio internacional</strong>
            <small>Entrega estimada em 12 a 20 dias</small>
          </span>
        </div>
      `;
    }

    return '';
  };

  const renderMixedShipmentNotice = (renderedItems) => {
    const hasInternational = renderedItems.some(function(entry) {
      return entry.presentation.origin === 'international';
    });

    const hasLocal = renderedItems.some(function(entry) {
      if (entry.presentation.origin === 'brasil') return true;

      // Products without the dual-fulfillment option remain standard local-stock items
      // in the current PlayBear Brazil architecture. Non-shipping items are excluded.
      return entry.presentation.origin === 'standard' && entry.item.requires_shipping !== false;
    });

    if (!hasInternational || !hasLocal) return '';

    return `
      <div class="tpb-split-shipping-notice" role="status">
        <span class="tpb-split-shipping-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 7h7v7H4z"></path>
            <path d="M13 10h7v7h-7z"></path>
            <path d="M7.5 14v3"></path>
            <path d="M16.5 7v3"></path>
          </svg>
        </span>
        <span class="tpb-split-shipping-copy">
          <strong>Envio em pacotes separados</strong>
          <span>Os itens do estoque no Brasil e os itens internacionais poderão ser enviados separadamente. O prazo estimado dos itens internacionais é de 12 a 20 dias após a confirmação do pagamento.</span>
        </span>
      </div>
    `;
  };

  const updateMixedShipmentNotice = (renderedItems) => {
    if (!checkoutActions) return;

    const existingNotice = checkoutActions.querySelector('.tpb-split-shipping-notice');
    if (existingNotice) existingNotice.remove();

    const noticeHTML = renderMixedShipmentNotice(renderedItems || []);
    if (noticeHTML) {
      checkoutActions.insertAdjacentHTML('afterbegin', noticeHTML);
    }
  };

  // Intercept header cart links and open the custom drawer.
  document.addEventListener('click', function(e) {
    const targetCart = e.target.closest('a[href="/cart"], a[href="/cart/"], a[href^="/cart?"], #cart-icon-bubble, .header__icon--cart, .cart-icon');
    if (targetCart && !targetCart.closest('#tpb-cart-drawer')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.openTacticalCart();
    }
  }, true);

  const updateGlobalHeaderCart = (count) => {
    const headerCartCounts = document.querySelectorAll('.cart-count-bubble, .header__cart-count span, [data-cart-count]');
    headerCartCounts.forEach(el => {
      el.textContent = count;
      if (count <= 0) {
        el.classList.add('hidden');
        el.style.display = 'none';
      } else {
        el.classList.remove('hidden');
        el.style.display = '';
      }
    });
  };

  const renderCheckoutButton = (itemCount) => {
    const checkoutBtn = drawer.querySelector('.tpb-btn-checkout');
    if (!checkoutBtn) return;

    if (itemCount <= 0) {
      checkoutBtn.disabled = true;
      checkoutBtn.style.opacity = '0.4';
      checkoutBtn.style.cursor = 'not-allowed';
      checkoutBtn.textContent = 'CARRINHO VAZIO ✕';
    } else if (isSyncing) {
      checkoutBtn.disabled = true;
      checkoutBtn.style.opacity = '0.7';
      checkoutBtn.style.cursor = 'wait';
      checkoutBtn.textContent = 'ATUALIZANDO... ⟳';
    } else {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '1';
      checkoutBtn.style.cursor = 'pointer';
      checkoutBtn.textContent = 'Finalizar Compra ➔';
    }

    syncFloatingCheckoutButton();
    updateFloatingCheckoutPosition();
  };

  window.openTacticalCart = () => {
    hideShopifyInboxForCart();
    startCartViewportTracking();
    lockStorefrontScroll();

    // The mobile layout scrolls the whole drawer. Always reopen from the top.
    drawer.scrollTop = 0;

    overlay.classList.add('is-active');
    drawer.classList.add('is-active');
    window.dispatchEvent(new CustomEvent('tpb:cart-drawer-opened'));
    fetchCart();
    requestAnimationFrame(updateFloatingCheckoutPosition);
  };

  const closeCart = () => {
    overlay.classList.remove('is-active');
    drawer.classList.remove('is-active');
    window.dispatchEvent(new CustomEvent('tpb:cart-drawer-closed'));
    restoreShopifyInboxAfterCart();
    stopCartViewportTracking();
    unlockStorefrontScroll();
    setFloatingCheckoutVisible(false);
  };

  overlay.addEventListener('click', closeCart);
  closeBtn.addEventListener('click', closeCart);

  window.addEventListener('tpb:cart-drawer-opened', hideShopifyInboxForCart);
  window.addEventListener('tpb:cart-drawer-closed', restoreShopifyInboxAfterCart);

  const renderCart = (cart) => {
    localCartState = JSON.parse(JSON.stringify(cart));

    if (drawer.classList.contains('is-active')) {
      updateCartViewportMetrics();
      window.dispatchEvent(new CustomEvent('tpb:cart-drawer-opened'));
    }

    countDisplay.textContent = cart.item_count;
    subtotalDisplay.textContent = formatMoney(cart.total_price);

    updateGlobalHeaderCart(cart.item_count);
    renderCheckoutButton(cart.item_count);

    if (cart.items.length === 0) {
      itemsContainer.innerHTML = '<div class="tpb-empty-cart-msg">Seu carrinho está vazio</div>';
      updateMixedShipmentNotice([]);
      updateFloatingCheckoutPosition();
      return;
    }

    const renderedItems = cart.items.map(function(item) {
      return {
        item: item,
        presentation: getItemPresentation(item)
      };
    });

    updateMixedShipmentNotice(renderedItems);

    let html = '';
    renderedItems.forEach(function(entry) {
      const item = entry.item;
      const presentation = entry.presentation;
      const safeKey = escapeHTML(item.key);
      const imageUrl = item.featured_image && item.featured_image.url
        ? item.featured_image.url
        : (item.image || '');

      html += `
        <div class="tpb-cart-item" id="item-${safeKey}">
          <div class="tpb-item-img">
            <img src="${escapeHTML(imageUrl)}" alt="${escapeHTML(item.product_title || item.title)}">
          </div>
          <div class="tpb-item-details">
            <div>
              <h4 class="tpb-item-title">${escapeHTML(item.product_title)}</h4>
              ${presentation.variantLabel ? `<div class="tpb-item-variant">${escapeHTML(presentation.variantLabel)}</div>` : ''}
              ${renderFulfillmentLabel(presentation)}
            </div>

            <div class="tpb-item-price-row">
              <div class="tpb-qty-controls">
                <button class="tpb-qty-btn tpb-qty-minus" data-key="${safeKey}">−</button>
                <span class="tpb-qty-num" data-qty="${item.quantity}">${item.quantity}</span>
                <button class="tpb-qty-btn tpb-qty-plus" data-key="${safeKey}">+</button>
              </div>

              <div class="tpb-item-actions">
                <span class="tpb-item-price">${formatMoney(item.line_price)}</span>
                <button class="tpb-item-remove" data-key="${safeKey}">REMOVER</button>
              </div>
            </div>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = html;
    updateFloatingCheckoutPosition();

    itemsContainer.querySelectorAll('.tpb-item-remove').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const key = this.getAttribute('data-key');
        const itemCard = document.getElementById(`item-${key}`);

        lastInteractionTime = Date.now();
        const currentInteraction = lastInteractionTime;
        isSyncing = true;

        if (itemCard) {
          itemCard.style.opacity = '0.3';
          itemCard.style.pointerEvents = 'none';
        }

        if (localCartState) {
          const itemIndex = localCartState.items.findIndex(i => i.key === key);
          if (itemIndex > -1) {
            const itemToDrop = localCartState.items[itemIndex];
            localCartState.total_price -= itemToDrop.line_price;
            localCartState.item_count -= itemToDrop.quantity;

            subtotalDisplay.textContent = formatMoney(localCartState.total_price);
            countDisplay.textContent = localCartState.item_count;

            renderCheckoutButton(localCartState.item_count);
            updateGlobalHeaderCart(localCartState.item_count);
          }
        }
        updateItem(key, 0, currentInteraction);
      });
    });

    itemsContainer.querySelectorAll('.tpb-qty-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        lastInteractionTime = Date.now();
        const currentInteraction = lastInteractionTime;
        isSyncing = true;

        const key = this.getAttribute('data-key');
        const numElement = this.parentElement.querySelector('.tpb-qty-num');

        let currentQty = parseInt(numElement.getAttribute('data-qty') || numElement.textContent, 10) || 0;
        const isPlus = this.classList.contains('tpb-qty-plus');

        let newQty = isPlus ? currentQty + 1 : currentQty - 1;
        if (newQty < 0) newQty = 0;

        numElement.textContent = newQty;
        numElement.setAttribute('data-qty', newQty);

        if (localCartState) {
          const item = localCartState.items.find(i => i.key === key);
          if (item) {
            const priceDiff = (newQty * item.price) - (currentQty * item.price);
            const qtyDiff = newQty - currentQty;

            localCartState.total_price += priceDiff;
            localCartState.item_count += qtyDiff;

            subtotalDisplay.textContent = formatMoney(localCartState.total_price);
            countDisplay.textContent = localCartState.item_count;
            updateGlobalHeaderCart(localCartState.item_count);

            const linePriceEl = this.closest('.tpb-item-price-row').querySelector('.tpb-item-price');
            if (linePriceEl) linePriceEl.textContent = formatMoney(newQty * item.price);

            renderCheckoutButton(localCartState.item_count);
          }
        }

        if (!window.cartTimers) window.cartTimers = {};
        clearTimeout(window.cartTimers[key]);

        window.cartTimers[key] = setTimeout(() => {
          updateItem(key, newQty, currentInteraction);
        }, 300);
      });
    });
  };

  const fetchCart = () => {
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

    fetch(rootUrl + 'cart.js?v=' + new Date().getTime())
      .then(response => response.json())
      .then(cart => {
        renderCart(cart);
      });
  };

  const updateItem = (key, qty, interactionTime) => {
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(response => response.json())
    .then(cart => {
      if (!interactionTime || interactionTime === lastInteractionTime) {
        isSyncing = false;
        renderCart(cart);
      }
    })
    .catch(error => {
      console.error('Error:', error);
      if (!interactionTime || interactionTime === lastInteractionTime) {
        isSyncing = false;
        fetchCart();
      }
    });
  };
});
